/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostTypeDtoPage } from '../../models/cost-type-dto-page';

export interface ListCostTypes$Params {
  query?: string;
  isLabor?: boolean | null;
  excludeIds?: Array<string>;
  projectId?: string | null;
  isActive?: boolean | null;
  isActiveOnNewProjects?: boolean | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'description' | '-description' | 'isActive' | '-isActive' | 'isActiveOnNewProjects' | '-isActiveOnNewProjects' | 'isLabor' | '-isLabor' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listCostTypes(http: HttpClient, rootUrl: string, params?: ListCostTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<CostTypeDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listCostTypes.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('isLabor', params.isLabor, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('projectId', params.projectId, {});
    rb.query('isActive', params.isActive, {});
    rb.query('isActiveOnNewProjects', params.isActiveOnNewProjects, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CostTypeDtoPage>;
    })
  );
}

listCostTypes.PATH = '/v0/costTypes';
